import { lazy } from 'react'

/**
 * This file is generally used to serve up files that get listed in the TinyMCE editor.
 * @type {React.LazyExoticComponent<function(): *>}
 */
const CareerHubCmsRoute = lazy(async () => {
  const { CareerHubCms } = await import(/* webpackChunkName: "careerhubcms" */ './index')

  return {
    default: CareerHubCms
  }
})
const routes = [
  {
    path: '/cms/',
    authenticated: true,
    render(props) {
      return <CareerHubCmsRoute {...props} />
    }
  }
]

export { routes }
